<div class="fgb-banner d-none d-lg-flex align-items-center" role="banner">
  <div class="container d-flex align-items-center justify-content-between">
    <ng-container *ngIf="isHomePage; else pageTitleBlock">
      <h1 class="text-white text-uppercase mb-0" *ngIf="memberDetails$ | async as memberDetails">
        {{ 'banner.welcome' | translate : { fgbdefault: 'Welcome,' } }} {{ memberDetails?.FirstName }}
      </h1>
    </ng-container>
    <ng-template #pageTitleBlock>
      <h1 class="text-white text-uppercase mb-0">{{ pageTitle }}</h1>
    </ng-template>
    <img [src]="'logos/logo-text.svg' | contentAssetImage" alt="" class="banner-logo" />
  </div>
</div>
